import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgReceiptAlt = function SvgReceiptAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.853 22.844a2.469 2.469 0 012.138-1.246c.88 0 1.694.475 2.138 1.246M12.577 22.844a2.469 2.469 0 012.138-1.246c.88 0 1.694.475 2.138 1.246"
  }), React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.13 22.844V1.156a2.478 2.478 0 01-2.139 1.247 2.477 2.477 0 01-2.138-1.247 2.477 2.477 0 01-2.138 1.247 2.476 2.476 0 01-2.138-1.247 2.477 2.477 0 01-2.138 1.247 2.477 2.477 0 01-2.138-1.247 2.477 2.477 0 01-2.138 1.247 2.477 2.477 0 01-2.138-1.247v21.688a2.47 2.47 0 012.138-1.246c.88 0 1.694.475 2.138 1.246a2.47 2.47 0 012.138-1.246c.88 0 1.694.475 2.138 1.246M7.97 6.94h3.537M7.97 11.277h4.984M7.97 15.614h3.537M16.016 6.94h1.032M16.016 11.277h1.032M16.016 15.614h1.032"
  }));
};

export default SvgReceiptAlt;